import { cn } from '@/lib/utils'

/**
 * Feature list in the references' style: a mono "+" marker in magenta and a
 * hairline rule above every row. Styling lives in the `.check-list` class in
 * globals.css, including the inverted palette when the list sits inside an
 * `.accent-surface`, so nothing here picks colours.
 *
 * Extracted 2026-08-08. The same list previously existed in three
 * incompatible dialects across the marketing pages — "+" with rules, "✓" in
 * cta, and "✓" in accent — at three different sizes.
 */
export function CheckList({
  items,
  className,
}: {
  items: readonly string[]
  className?: string
}) {
  return (
    <ul className={cn('check-list', className)}>
      {items.map(item => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  )
}

export default CheckList
